import { Component, OnInit, Input, forwardRef } from '@angular/core';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { 
    NavController, IonGrid, IonRow, IonCol, ModalController
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import { GoogleMap, MapMarker } from '@angular/google-maps';
import { Subscription } from 'rxjs';

import { MarvFieldComponent, MarvSectionTitleComponent, MarvToggleComponent, MarvMessageComponent, MarvTagComponent } from '@marv/components';
import { StoreDetailsInfos, StoreDetailsKpiComponent, OperationItem, OperationItemComponent } from '@app/components';
import { MissionTypeService } from '@app/services';

@Component({
    selector: 'app-store-details-infos',
    templateUrl: './infos.component.html',
    styleUrls: ['./infos.component.scss'],
    imports: [
        IonGrid, IonRow, IonCol, TranslatePipe, GoogleMap, MapMarker, ReactiveFormsModule,
        forwardRef(() => MarvFieldComponent), forwardRef(() => MarvSectionTitleComponent), forwardRef(() => MarvToggleComponent), 
        forwardRef(() => MarvMessageComponent), forwardRef(() => MarvTagComponent), 
        forwardRef(() => StoreDetailsKpiComponent), forwardRef(() => OperationItemComponent)
    ]
})
export class StoreDetailsInfosComponent  implements OnInit {

    @Input({alias : 'store', required : true}) store: StoreDetailsInfos;

    showMap: boolean = false;
    optionsMap: google.maps.MapOptions = {
        cameraControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        zoom: 14
    };
    centerMap: google.maps.LatLngLiteral;
    operationsStore: Array<OperationItem> = [];
    operationsForm: FormGroup = new FormGroup({
        activesOnly: new FormControl(true)
    });
    
    operationsSubscription: Subscription; 

    constructor(
        private navController: NavController,
        private modalController: ModalController,
        public missionTypeService: MissionTypeService
    ) { }

    ngOnInit() {
        
        if(this.store.latitude && this.store.longitude){
            this.showMap = true;
            this.centerMap = {
                lat: this.store.latitude,
                lng: this.store.longitude
            };
        }
        
        this.getOperationsStore();
        this.operationsSubscription = this.operationsForm.controls['activesOnly'].valueChanges.subscribe(newValue => {
           this.getOperationsStore();
        });    
    }
    
    ngOnDestroy() {
        if(this.operationsSubscription){
            this.operationsSubscription.unsubscribe();
        }        
    }

    getOperationsStore(){
        if(!this.operationsForm.controls['activesOnly'].value){
            this.operationsStore = this.store.operations;
        }
        else{
            this.operationsStore = this.store.operations.filter(o => !o.hiddenByDefault);       
        }
    }

    addIntervention(operationItem: OperationItem){
        let params = {
            operationId: operationItem.id,
            storeId: this.store.id
        };
        this.modalController.dismiss();        
        this.navController.navigateRoot('permanent-planning', {queryParams: params});
    }
}
